import { Survey } from "../models/survey.model";
import { Store, StoresAndUser } from "../models/store.model";
import { User } from "../models/user.model";
import { StoreStateModel } from "../state/store.state";

export namespace StoreActions {
    export class Refresh {
        static readonly type = '[API-Store] Refresh'
        constructor(public payload: User) {}
    }
    export class Init {
        static readonly type = '[Storage-Store] Init'
        constructor(public payload: StoreStateModel) {}
    }
    export class Set {
        static readonly type = '[API-Store] Set'
        constructor(public payload: StoresAndUser) {}
    }
}
